"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelfSufficientSettlementRebalanced = void 0;
var Tags_1 = require("../../Tags");
var PreludeCard_1 = require("../../prelude/PreludeCard");
var Resources_1 = require("../../../Resources");
var CardName_1 = require("../../../CardName");
var PlaceCityTile_1 = require("../../../deferredActions/PlaceCityTile");
var CardRenderer_1 = require("../../render/CardRenderer");
var Units_1 = require("../../../Units");
var SelfSufficientSettlementRebalanced = (function (_super) {
    __extends(SelfSufficientSettlementRebalanced, _super);
    function SelfSufficientSettlementRebalanced() {
        return _super.call(this, {
            name: CardName_1.CardName.SELF_SUFFICIENT_SETTLEMENT_REBALANCED,
            tags: [Tags_1.Tags.BUILDING, Tags_1.Tags.CITY],
            productionBox: Units_1.Units.of({ megacredits: 2 }),
            metadata: {
                cardNumber: 'P29',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.production(function (pb) { return pb.megacredits(2); }).megacredits(3).br.city();
                }),
                description: 'Increase your money production 2 steps. Gain 3 MC. Place a City tile.',
            },
        }) || this;
    }
    SelfSufficientSettlementRebalanced.prototype.play = function (player) {
        player.addProduction(Resources_1.Resources.MEGACREDITS, 2);
        player.megaCredits += 3;
        player.game.defer(new PlaceCityTile_1.PlaceCityTile(player));
        return undefined;
    };
    return SelfSufficientSettlementRebalanced;
}(PreludeCard_1.PreludeCard));
exports.SelfSufficientSettlementRebalanced = SelfSufficientSettlementRebalanced;
//# sourceMappingURL=SelfSufficientSettlementRebalanced.js.map